import { render, staticRenderFns } from "./AddEntitySublist.vue?vue&type=template&id=232f95ae&scoped=true"
import script from "./AddEntitySublist.vue?vue&type=script&lang=js"
export * from "./AddEntitySublist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232f95ae",
  null
  
)

export default component.exports